/**
 * Created by Jie Gao on 2020-04-30.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {GGGameAssets} from "../GGGameAssets";
import {ImageIntroPage} from "./ImageIntroPage";
import {GoldenGoblins} from "../GoldenGoblins";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class GGIntroConfig implements GameIntroViewConfig {
    private static INTRO_BG = GGGameAssets.INTRO_BACKGROUND;
    private static MAIN_BACKGROUND = GGGameAssets.MAIN_BACKGROUND;
    private static INTRO_LOGO = GGGameAssets.INTRO_LOGO;
    private static INTRO_FEATURE_1 = "resources/images/intro/GoblinFeast.png";
    private static INTRO_FEATURE_2 = "resources/images/intro/FreshMeatSpins.png";
    private static INTRO_FEATURE_3 = "resources/images/intro/resurrection-wilds.png";
    private static INTRO_FEATURE_4 = "resources/images/intro/xBomb.png";
    private static INTRO_FEATURE_5 = "resources/images/intro/goblin-sacrifice.png";
    private static INTRO_FEATURE_6 = "resources/images/intro/evil4.png";
    private static INTRO_FEATURE_7 = "resources/images/intro/Maxcap.png";
    private static INTRO_BAR_TOP = "resources/images/intro/border1.png";
    private static INTRO_BAR_BOTTOM = "resources/images/intro/border2.png";

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000,
            bulletColor: 0xffffff
        },
        stampColor: 0xFFFFFF,
    };
    stampConfig: StampConfig = {
        xBomb: true,
        volatility: Volatility.EXTREME
    };
    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(GGIntroConfig.INTRO_BG, GGIntroConfig.INTRO_BG);
        imgLoader.add(GGIntroConfig.MAIN_BACKGROUND, GGIntroConfig.MAIN_BACKGROUND);
        imgLoader.add(GGIntroConfig.INTRO_LOGO, GGIntroConfig.INTRO_LOGO);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_1, GGIntroConfig.INTRO_FEATURE_1);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_2, GGIntroConfig.INTRO_FEATURE_2);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_3, GGIntroConfig.INTRO_FEATURE_3);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_4, GGIntroConfig.INTRO_FEATURE_4);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_5, GGIntroConfig.INTRO_FEATURE_5);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_6, GGIntroConfig.INTRO_FEATURE_6);
        imgLoader.add(GGIntroConfig.INTRO_FEATURE_7, GGIntroConfig.INTRO_FEATURE_7);
        imgLoader.add(GGIntroConfig.INTRO_BAR_TOP, GGIntroConfig.INTRO_BAR_TOP);
        imgLoader.add(GGIntroConfig.INTRO_BAR_BOTTOM, GGIntroConfig.INTRO_BAR_BOTTOM);

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(GGIntroConfig.INTRO_BG));
        bgSprite.anchor.set(0.5, 0.5);

        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture(GGIntroConfig.INTRO_BAR_TOP));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture(GGIntroConfig.INTRO_BAR_BOTTOM));
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(GGIntroConfig.INTRO_LOGO));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        this.pages = [
            new ImageIntroPage({
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_1),
                scale: 1,
                position: new PIXI.Point(-190, 0)
            }, {
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_2),
                scale: 1,
                position: new PIXI.Point(190, 0)
            }),
            new ImageIntroPage({
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_3),
                scale: 1,
                position: new PIXI.Point(-170, 0)
            }, {
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_4),
                scale: 1,
                position: new PIXI.Point(210, 0)
            }),
            new ImageIntroPage({
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_5),
                scale: 1,
                position: new PIXI.Point(-200, 0)
            }, {
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_6),
                scale: 1,
                position: new PIXI.Point(170, 0)
            })
        ];

        if (GoldenGoblins.api.gameClientConfiguration.isSet) {
            this.addWincapPage();
        } else {
            GoldenGoblins.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.addWincapPage();
            });
        }
    }

    private addWincapPage(): void {
        if (!GoldenGoblins.api.gameClientConfiguration.replaceWincapInfo) {
            this.pages.push(new ImageIntroPage({
                texture: ImgLoader.getImgTexture(GGIntroConfig.INTRO_FEATURE_7),
                scale: 1,
                position: new PIXI.Point(0, 0)
            }));
        }
    }
}